<script>
import { cloneDeep, isEqual } from 'lodash-es'
/* eslint-disable no-undef */
export default {
    name: 'CalendarFilters',

    props: {
        searchEndpoint: {
            type: String,
            required: true
        },
        filterOptions: {
            type: Object,
            required: true
        },
        initFilterState: {
            type: Object,
            required: false,
            default: () => null
        },
        initFilterStates: {
            type: Array,
            required: false,
            default: () => []
        },
        mode: {
            type: String,
            required: false,
            default: () => 'web'
        },
    },

    data() {
        return {
            searchInOccasions: '',
            filterState: {
                date: {
                    start: null,
                    end: null
                },

                categories: [],
                genres: [],
                audiences: [],
                locations: [],

                onlineEvent: false,
                freeParticipation: false,
                accessible: false,
            },
            resetFilterState: null,

            headerHeight: null,
            viewSelector: null,
            audiencesRadio: null,
            subView: this.mode === 'web' ? 'search' : 'filters',
        }
    },

    watch: {
        filterState: {
            deep: true,
            handler(newValue) {
                this.$emit('update-filter-state', newValue)

                let audiences = []
                let categories = []
                let startDate = ''
                let endDate = ''
                let genres = []
                let locations = []

                if (newValue.audiences.length > 0) {
                    newValue.audiences.forEach((element) => {
                        audiences.push(element.name)
                    })
                }

                if (newValue.categories.length > 0) {
                    newValue.categories.forEach((element) => {
                        categories.push(element.id)
                    })
                }

                if (newValue.date.start && newValue.date.end) {
                    startDate = new Date(newValue.date.start).toLocaleDateString()
                    endDate = new Date(newValue.date.end).toLocaleDateString()
                }

                if (newValue.genres.length > 0) {
                    newValue.genres.forEach((element) => {
                        genres.push(element.id)
                    })
                }

                if (newValue.locations.length > 0) {
                    newValue.locations.forEach((element) => {
                        locations.push(element.id)
                    })
                }

                if (audiences.length > 0 || categories.length > 0 || genres.length > 0 || locations.length > 0 || startDate !== '' || endDate !== '') {
                    let url = new URLSearchParams({
                        'audiences': audiences,
                        'categories': categories,
                        'startDate': startDate,
                        'endDate': endDate,
                        'genres': genres,
                        'locations': locations,
                        'freeParticipation': newValue.freeParticipation,
                    }).toString()

                    const urlObject = new URL(window.location.href)

                    window.history.pushState(null, '', urlObject.pathname + '?' + url)
                }
            }
        }
    },

    created() {
        this.resetFilterState = cloneDeep(this.filterState)

        if (this.initFilterStates.length > 0) {
            this.initFilterStates.forEach((filter) => {
                if (Array.isArray(filter.value)) {
                    if (filter.name === 'audiences') {
                        filter.value.forEach((name) => {
                            this.filterState[filter.name].push(this.filterOptions['childrenConcerts'].filter((item) => item.name == name)[0])
                            this.filterState['childrenConcerts'] = this.filterOptions['childrenConcerts'].filter((item) => item.name == name)[0]
                        })
                    } else {
                        filter.value.forEach((id) => {
                            this.filterState[filter.name].push(this.filterOptions[filter.name].filter((item) => item.id == id)[0])
                        })
                    }
                } else {
                    if (filter.name === 'startDate') {
                        this.filterState['date']['start'] = new Date(filter.value)
                    } else if (filter.name === 'endDate') {
                        this.filterState['date']['end'] = new Date(filter.value)
                    } else {
                        this.filterState[filter.name] = filter.value
                    }
                }
            })

            this.setSubView('filters')
            this.$emit('update-filter-state', this.filterState)
            this.doFilter()
        }

        if ( this.initFilterState ) {
            if ( this.initFilterState.value.length ) {
                this.initFilterState.value.forEach( (elem) => {
                    this.filterState[this.initFilterState.filter].push(elem)
                })
            } else {
                this.filterState[this.initFilterState.filter].push(this.initFilterState.value)
            }
            this.$emit('update-filter-state', this.filterState)
        }
    },

    mounted() {
        this.headerHeight = document.getElementById('zen-page-header').offsetHeight
        this.viewSelector = document.getElementById('view-selector')
    },

    methods: {
        isFiltersEmpty() {
            return isEqual(this.filterState, this.resetFilterState)
        },

        getMoment(date) {
            return moment(date)
        },

        check(feature) {
            if ( this.filterState[feature] ) {
                this.$set(this.filterState, feature, false)
            }
        },

        checkAudiences(feature) {
            if (this.filterState.audiences.length) {
                this.filterState.audiences = []
                this.audiencesRadio = false
            } else {
                this.filterState.audiences.push(feature)
            }
        },

        handleSelectInput(destination, payload) {
            this.$set(this.filterState, destination, payload)
        },

        doFilter() {
            this.$emit('do-filter', )
            this.$scrollTo(this.viewSelector, 500, { offset: 0-this.headerHeight })
        },

        clearFilter() {
            const urlObject = new URL(window.location.href)

            if ( this.isFiltersEmpty() ) { return }

            this.filterState = cloneDeep(this.resetFilterState)
            window.history.pushState(null, '', urlObject.pathname)

            this.$nextTick(() => {
                this.doFilter()
            })
        },

        setSubView(_subView) {
            if ( _subView === this.subView ) { return }
            this.subView = _subView
        },

        goSearch() {
            window.location = this.searchEndpoint+'?query='+this.searchInOccasions
        },

        childrenConcert(event) {
            if (event[0]) {
                this.checkAudiences({
                    name: event[0].name
                })
            } else {
                this.filterState.audiences = []
            }
        }
    }
}
</script>

<template>
    <div
        id="calendar-filters-container"
        class="container-fluid calendar-filters"
    >
        <div class="calendar-filter-bg-wrapper">
            <svg class="calendar-filter-bg">
                <use xlink:href="#calendar-filter-bg-new" />
            </svg>
        </div>
        <div class="container position-relative pb-4 pb-sm-5">
            <div class="pt-3">
                <h1>{{ __('Naptár') }}</h1>
            </div>

            <!-- Filters / Search selector -->
            <div class="d-flex justify-content-between align-items-end pt-5">
                <div class="d-flex align-items-end filter-search-selector text-selection-none">
                    <button
                        class="text-uppercase filter-search-item mr-2 no-btn"
                        :class="{
                            'active-view': subView === 'filters'
                        }"
                        tabindex="0"
                        @click="setSubView('filters')"
                    >
                        {{ __('Advanced search') }}
                    </button>
                    <button
                        v-if="mode === 'web'"
                        class="text-uppercase filter-search-item mx-2 no-btn"
                        :class="{
                            'active-view': subView === 'search',
                        }"
                        tabindex="0"
                        @click="setSubView('search')"
                    >
                        {{ __('Search') }}
                    </button>
                </div>
            </div>

            <!-- Filters section -->
            <div v-show="subView === 'filters'">
                <div class="row pt-3">
                    <div class="col-12 col-md-4">
                        <div class="filter-field-label">
                            {{ __('Date') }} <span class="hint">({{ __('Select start and end dates') }})</span>
                        </div>
                        <v-dropdown
                            :offset="[0, 5]"
                            role="button"
                            tabindex="0"
                        >
                            <!-- This will be the popover reference (for the events and position) -->
                            <div class="custom-date-range-field d-flex align-items-center justify-content-between">
                                <div v-if="filterState.date.start !== null && filterState.date.end !== null">
                                    {{ dateFormatDayPER(getMoment(filterState.date.start)) }} - {{ dateFormatDayPER(getMoment(filterState.date.end)) }}
                                </div>
                                <div
                                    v-else
                                >
                                    {{ __('Choose date range') }}
                                </div>
                                <div class="pl-2">
                                    <svg class="icon icon-cal-select-calendar">
                                        <use xlink:href="#cal-select-calendar" />
                                    </svg>
                                </div>
                            </div>

                            <!-- This will be the content of the popover -->
                            <template #popper>
                                <v-date-picker
                                    v-model="filterState.date"
                                    mode="date"
                                    is-range
                                    :locale="appLocale"
                                    :masks="{ title: 'YYYY. MMM' }"
                                    trim-weeks
                                    tabindex="0"
                                />
                                <div class="p-2">
                                    <button
                                        v-close-popper
                                        class="btn btn-primary w-100"
                                    >
                                        Ok
                                    </button>
                                </div>
                            </template>
                        </v-dropdown>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="filter-field-label">
                            {{ __('Type') }}
                        </div>
                        <zh-multiselect
                            :options="filterOptions.categories"
                            :init-selected="filterState.categories"
                            :placeholder="__('Show all types')"
                            @input="handleSelectInput('categories', $event)"
                        />
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="filter-field-label">
                            {{ __('Genre') }}
                        </div>
                        <zh-multiselect
                            :options="filterOptions.genres"
                            :init-selected="filterState.genres"
                            :placeholder="__('Show all genres')"
                            @input="handleSelectInput('genres', $event)"
                        />
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="filter-field-label">
                            {{ __('Location') }}
                        </div>
                        <zh-multiselect
                            :options="filterOptions.locations"
                            :init-selected="filterState.locations"
                            :placeholder="__('Show all locations')"
                            @input="handleSelectInput('locations', $event)"
                        />
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="filter-field-label">
                            {{ __(('For children')) }}
                        </div>
                        <zh-multiselect
                            :options="filterOptions.childrenConcerts"
                            :init-selected="filterState.childrenConcerts"
                            :placeholder="__('Show all types')"
                            @input="childrenConcert($event)"
                        />
                    </div>
                </div>
                <!-- RADIOS BELOW -->
                <div class="row pt-3">
                    <div class="col-6 col-md-2 pb-2 pb-md-0 pt-2">
                        <label
                            class="form-radio-control"
                            for="free_participation"
                        >
                            <input
                                id="free_participation"
                                v-model="filterState.freeParticipation"
                                type="radio"
                                :value="true"
                                @click="check('freeParticipation')"
                            >
                            <span class="form-radio-label">
                                {{ __(('Free participation')) }}
                            </span>
                        </label>
                    </div>
                    <div class="col-12 col-md-4 ml-auto">
                        <div class="d-flex pt-3 pt-sm-0">
                            <button
                                :class="{ disabled: isFiltersEmpty() }"
                                class="btn btn-secondary w-100 mr-2"
                                @click.prevent="clearFilter"
                            >
                                {{ __('Clear filter') }}
                            </button>
                            <button
                                class="btn btn-secondary w-100 ml-2"
                                @click.prevent="doFilter"
                            >
                                {{ __('Filter') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Search section -->
            <div v-show="subView === 'search' && mode === 'web'">
                <div class="row pt-5">
                    <div class="col-12 col-sm-10">
                        <div class="input-group search">
                            <input
                                v-model="searchInOccasions"
                                type="text"
                                class="form-control px-3"
                                :placeholder="__('Search in occasions...')"
                            >
                            <span class="input-group-append d-flex align-items-center">
                                <svg class="icon icon-search"><use xlink:href="#icon-search" /></svg>
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-sm-2">
                        <button
                            class="btn btn-secondary w-100 ml-2"
                            @click.prevent="goSearch"
                        >
                            {{ __('Search') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="v-tooltip/dist/v-tooltip.css"></style>

<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";
@import 'bootstrap/scss/_mixins.scss';

.calendar-filter-bg-wrapper {
    position: absolute;
    right: 0;
    @include media-breakpoint-up(md) {
        left: calc(50vw - 716px);
    }
}

.calendar-filter-bg {
    max-width: 100vw;
    width: 716px;
    height: 309px;
}

.input-group.search {
    padding-top: 5px;
    border-bottom: 1px solid $zh-suplementary-lblue;

    input {
        height: 30px !important;
        color: white;
        outline: none;
        border: none;
        font-size: 20px;
        font-weight: normal;
        margin-bottom: 2px;
        padding-left: 0;
        padding-right: 10px;
        background-color: transparent;
        height: calc(1.8em + 1rem + 2px);

        &:focus {
            box-shadow: none;
            color: white !important;
        }

        &::placeholder {
            color: $zh-suplementary-lblue;
        }
    }
}

.icon-search {
    --icon-color:  #{$zh-suplementary-lblue};
    width: 20px;
    height: 20px;
}

.filter-search-selector {
    color: white;
    font-size: 12px;
}

.filter-search-item {
    cursor: pointer;
    color: #fff;
}

.filter-search-item.active-view {
    cursor: default;
    font-size: 20px;
    line-height: 30px;
    border-bottom: 3px solid !important;
}

.btn {
    font-weight: 400;
}

.btn.btn-secondary.disabled {
    background: transparent;
}

.filter-field-label {
    font-size: 10px;
    text-transform: uppercase;
    color: #B3CFEF;
    padding: 0.5rem 0 0.4rem 1rem;

    .hint {
        text-transform: none;
    }
}

// RADIO BELOW

.form-radio-control {
  display: grid;
  grid-template-columns: 26px 1fr;
  gap: 0.8rem;
  font-size: 12px;
  justify-content: center;
  align-content: center;
}

.form-radio-label {
    display: flex;
    align-items: center;
}

input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: transparent;
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 26px;
  height: 26px;
  border: 1px solid #ffffff4d;
  border-radius: 50%;

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 20px 20px #B3CFEF;
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

// DATEPICKER BELOW
.v-popper {
    width: 100% !important;
}

.custom-date-range-field {
    font-size: 12px;
    letter-spacing: 1.5px;
    padding: 0px 14px;
    min-height: 40px;
    border: 1px solid;
    background: #0068B1;
    border-radius: 20px;
    border-color: #ffffff4d;
    cursor: pointer;
}

.vc-container {
    border: none !important;
}

::v-deep .vc-title {
    text-transform: uppercase;
}
</style>
